import { ApiService, HttpMethod } from '../_common/api.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IotChangePercentAdjustParams } from './models/iot-change-percent-adjust-params';
import { IotRequestParams } from './models/iot-request-params.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LynxDriveApiService {

    private apiService: ApiService;

    // =========================================================================================================================================================
    // Ctor
    // =========================================================================================================================================================

    constructor(http: HttpClient
    ) {
        this.apiService = new ApiService(http);
    }

    // =========================================================================================================================================================
    // Public Methods
    // =========================================================================================================================================================

    requestPing(requestParams: IotRequestParams): Observable<void> {
        return this.apiService.apiRequest<any>(LynxDriveApiService.requestPingUrl, HttpMethod.Post, requestParams);
    }

    requestCourses(requestParams: IotRequestParams): Observable<void> {
        return this.apiService.apiRequest<any>(LynxDriveApiService.requestCoursesUrl, HttpMethod.Post, requestParams);
    }

    requestStations(courseId: number, requestParams: IotRequestParams): Observable<void> {
        return this.apiService.apiRequest<any>(LynxDriveApiService.getRequestStationsUrl(courseId), HttpMethod.Post, requestParams);
    }

    requestProgramTopo(courseId: number, requestParams: IotRequestParams): Observable<void> {
        return this.apiService.apiRequest<any>(LynxDriveApiService.getRequestProgramTopoUrl(courseId), HttpMethod.Post, requestParams);
    }

    requestPercentAdjustments(courseId: number, requestParams: IotRequestParams): Observable<void> {
        return this.apiService.apiRequest<any>(LynxDriveApiService.getRequestPercentAdjustmentsUrl(courseId), HttpMethod.Post, requestParams);
    }

    requestChangePercentAdjust(requestParams: IotChangePercentAdjustParams): Observable<void> {
        return this.apiService.apiRequest<any>(LynxDriveApiService.requestChangePercentAdjustmentsUrl, HttpMethod.Post, requestParams);
    }

    requestGeoTopo(courseId: number, requestParams: IotRequestParams): Observable<void> {
        return this.apiService.apiRequest<any>(LynxDriveApiService.getRequestGeoTopoUrl(courseId), HttpMethod.Post, requestParams);
    }

    requestCourseReport(courseId: number, requestParams: IotRequestParams): Observable<void> {
        return this.apiService.apiRequest<any>(LynxDriveApiService.getRequestCourseReportUrl(courseId), HttpMethod.Post, requestParams);
    }


    // =========================================================================================================================================================
    // URLs
    // =========================================================================================================================================================

    private static get baseUrl(): string { return `${ApiService.baseApiUrl}IotMqtt`; }

    private static get requestPingUrl(): string { return `${this.baseUrl}/ping`}

    private static get requestCoursesUrl(): string { return `${this.baseUrl}/courses/request`}

    private static getRequestStationsUrl(courseId: number): string { return `${this.baseUrl}/courses/${courseId}/stations/request`}

    private static getRequestProgramTopoUrl(courseId: number): string { return `${this.baseUrl}/courses/${courseId}/programTopo/request`}

    private static getRequestPercentAdjustmentsUrl(courseId: number): string { return `${this.baseUrl}/courses/${courseId}/percentAdjustments/request`}

    private static get requestChangePercentAdjustmentsUrl(): string { return `${this.baseUrl}/percentAdjustments/change/request`}

    private static getRequestGeoTopoUrl(courseId: number): string { return `${this.baseUrl}/courses/${courseId}/geoTopo/request`}

    private static getRequestCourseReportUrl(courseId: number): string { return `${this.baseUrl}/courses/${courseId}/courseReport/request`}
}
